const d = {
    CustomEvent: "ce",
    Pr: "p",
    gc: "pc",
    Ac: "ca",
    Mu: "i",
    Tu: "ie",
    xt: "cci",
    $t: "ccic",
    lt: "ccc",
    dt: "ccd",
    Kl: "ss",
    Gl: "se",
    Ir: "si",
    Mr: "sc",
    Tr: "sbc",
    Mc: "sfe",
    zo: "iec",
    fc: "lr",
    mc: "uae",
    yt: "ci",
    ut: "cc",
    wc: "lcaa",
    bc: "lcar",
    Xn: "inc",
    Jn: "add",
    Qn: "rem",
    Hn: "set",
    Kn: "ncam",
    kc: "sgu",
    yr: "ffi",
    ro: "bi",
    ds: "bc",
  },
  dr = { Fr: "feed_displayed", Sc: "content_cards_displayed" };
export { d as EventTypes, dr as InternalEventTypes };
